import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Region from "./views/Region.vue";
import ObservationForm from "./views/ObservationForm.vue";
import Observation from "./views/Observation.vue";
import Subscriptions from "./views/Subscriptions.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "regions",
      component: Home
    },
    {
      path: "/observations",
      name: "observations",
      component: Home
    },
    {
      path: "/region/:id",
      name: "region",
      component: Region
    },
    {
      path: "/observation/submit",
      name: "observationform",
      component: ObservationForm
    },
    {
      path: "/observation/:id",
      name: "observation",
      component: Observation
    },
    {
      path: "/subscriptions/:key",
      name: "subscriptions",
      component: Subscriptions
    }
  ]
});
